/* eslint-disable react/jsx-closing-tag-location */
import React, { Component } from 'react';
import * as moment from 'moment';

import DateFnsUtils from '@date-io/date-fns';
import FormHelperText from '@material-ui/core/FormHelperText';
import esLocale from 'date-fns/locale/es';
import enLocale from 'date-fns/locale/en-US';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { withTranslation } from 'react-i18next';
import PageHeaderTitle from './Profile/PageHeaderTitle';
import MobileFooter from './Profile/MobileFooter';
import { Grid } from '@material-ui/core';
import { hot } from 'react-hot-loader';

const localeMap = {
	'en-US': enLocale,
	'es-ES': esLocale
};

class ResumePaymentDate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_disbursalDate: new Date().setDate(new Date().getDate() + 1),
			_error: '',
			_disabled: true
		};
	}

	handleDateChange = date => {
		if (
			moment(date).diff(moment(), 'day') < 0 ||
			date.toDateString() === new Date().toDateString() ||
			moment(date).format() === 'Invalid date'
		) {
			this.setState({
				_disbursalDate: date,
				_error: '',
				_disabled: true
			});
		} else {
			this.setState({
				_disbursalDate: date,
				_error: '',
				_disabled: false
			});
		}
	};

	handleContinue = () => {
		const resume_date = this.state._disbursalDate.toISOString();
		this.props.handleContinue(resume_date);
		this.props.handleBack();
	};

	render() {
		const { t, i18n } = this.props;
		const date = new Date();
		return (
			<section className="resume_payment_container">
				<PageHeaderTitle
					title="Resume All Payments"
					className="p-x-16 resume_payment"
					isMobile={true}
					onClick={this.props.handleBack}
				/>
				<div className="demo-container resume_payment mdl-grid">
					<div className="demo-content mdl-color--white content  mdl-cell">
						<Grid sm={8} xs={12} className="resume_payment_item_container">
							<div className="mdl-grid">
								<div className="mdl-cell mdl-cell--12-col center-items">
									<h4 className="text-center resume-heading">
										{t('app_message.heading_for_resume_payment_screen')}
									</h4>
								</div>
							</div>
							<div className="mdl-grid center-items">
								<div className="mdl-cell mdl-cell--10-col ">
									<MuiPickersUtilsProvider
										locale={localeMap[i18n.language] || enLocale}
										utils={DateFnsUtils}>
										<KeyboardDatePicker
											autoOk
											format="MM/dd/yyyy"
											fullWidth
											id="date-picker-dialog"
											invalidDateMessage={t('error_message.invalid_date')}
											KeyboardButtonProps={{
												'aria-label': 'change date'
											}}
											label=""
											placeholder="MM/DD/YYYY"
											margin="normal"
											maxDateMessage={t('error_message.default_max_date_error')}
											minDate={date.setDate(date.getDate() + 1)}
											minDateMessage={t('error_message.default_min_date_error')}
											onChange={this.handleDateChange}
											value={this.state._disbursalDate}
										/>
									</MuiPickersUtilsProvider>
									<FormHelperText id="text-red">{this.state._error}</FormHelperText>

									<MobileFooter
										textButtonContinue={t('buttons.continue')}
										hasNext={true}
										disabled={this.state._disabled}
										onSubmit={this.handleContinue}
										onClick={this.props.handleBack}
									/>
								</div>
							</div>
						</Grid>
					</div>
				</div>
			</section>
		);
	}
}

export default hot(module)(withTranslation()(ResumePaymentDate));
